<mat-checkbox
  color="primary"
  [formControl]="control"
  [title]="control.disabled ? 'Add a name, email or phone first — there is no contact to silence' : ''"
>
  Silence SMS &amp; email notifications
</mat-checkbox>
